import { createEntityAdapter } from '@reduxjs/toolkit';
import { ControlUnitAPIResponse } from '../ControlUnit.model';

export const ControlUnitAdapter = createEntityAdapter<ControlUnitAPIResponse>({
  selectId: (controlUnit: ControlUnitAPIResponse) => controlUnit.id,
});
